import React from "react";
import { Check } from "lucide-react";

// Compact per-client workflow pills: done (filled), current (ring), pending (hollow).
export function ProgressPills({ progress = [], compact = false }) {
  const firstPending = progress.findIndex((p) => !p.done);
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="progress-pills">
      {progress.map((p, i) => {
        const isCurrent = i === firstPending;
        const state = p.done ? "done" : isCurrent ? "current" : "pending";
        return (
          <div key={p.label} className="flex items-center gap-1.5" data-testid={`pill-${p.label.toLowerCase().replace(/\s+/g, "-")}-${state}`}>
            <span
              className={
                "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium border transition " +
                (p.done
                  ? "bg-emerald-500/15 border-emerald-500/40 text-emerald-300"
                  : isCurrent
                  ? "bg-brand/15 border-brand/50 text-brand"
                  : "bg-white/[0.03] border-line text-mutedText")
              }
            >
              {p.done ? <Check size={11} /> : <span className={"h-1.5 w-1.5 rounded-full " + (isCurrent ? "bg-brand" : "bg-mutedText/50")} />}
              {!compact && p.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
